import React from 'react';


const Footer = (props) => {
    return (
        <footer className="page-footer font-small border-top border-dark">

            <div className="container-fluid">
                <div className="row">

                    <div className="col-12 py-3">
                        <div className="flex-center">

                            <p>
                                <img className="float-left mr-2"
                                     src="flag_yellow_high-300x200.jpg" alt=""
                                     width="60" height="40"/>
                                This research was undertaken by{" "}
                                <a href="https://finki.ukim.mk/en" target="__blank">CSE</a>{" "}
                                and the{" "}
                                <a href="https://cs.ijs.si" target="__blank">Jozef Stefan Institute (JSI, SI)</a>, a beneficiary in{" "}
                                <a href="https://www.fns-cloud.eu" target="__blank">FNS-Cloud</a>,
                                which has received funding from the European Union’s Horizon 2020 Research and
                                Innovation programme
                                (H2020-EU.3.2.2.3. – A sustainable and competitive agri-food industry) under Grant
                                Agreement No.
                                863059
                                –
                                <a href="https://www.fns-cloud.eu">www.fns-cloud.eu</a>.

                                Also, it has been supported by the
                                <a href="https://www.efsa.europa.eu/en" target="__blank">
                                    European Food Safety Agency</a>{" "} under the Grant Agreement
                                No.
                                GP/EFSA/AMU/2020/03/LOT2.
                            </p>
                            <div className="flex-center">
                                <a href="https://www.fns-cloud.eu/" className="pl-3 pr-3" target="__blank"
                                   title="FNS-Cloud">
                                    <img className="align-left" src="FNSCloud_color_C.png" height="60"/>
                                </a>

                                <a href="https://www.efsa.europa.eu/en" className="pl-3 pr-3" target="__blank"
                                   title="EFSA">
                                    <img className="align-left" src="EFSA_logo_EN_RGB.jpeg" height="60"/>
                                </a>

                                <a href="https://www.innoradar.eu/" className="pl-3 pr-3" target="__blank"
                                   title="Innovation Radar">
                                    <img className="align-left" src="ir-logo.png" height="60"/>
                                </a>

                                <a href="https://finki.ukim.mk/en" className="pl-3 pr-3" target="__blank"
                                   title="CSE, UKIM">
                                    <img className="align-left" src="finki.png" height="60"/>
                                </a>

                                <a href="https://cs.ijs.si/" className="pl-3 pr-3" target="__blank"
                                   title="Jozef Stefan Institute (JSI, SI)">
                                    <img className="align-left" src="jsi.png" height="60"/>
                                </a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </footer>
    )
}
export default Footer;
